import { StatusBadge } from "@/components/common/StatusBadge";
import { fmtNum } from "@/lib/api";

const TONE = { connected: "ok", configured: "pending", unavailable: "unavailable" };

export function CoverageStrip({ coverage = [], compact = false }) {
  return (
    <div className={`grid gap-3 ${compact ? "sm:grid-cols-2" : "sm:grid-cols-2 xl:grid-cols-4"}`} data-testid="coverage-strip">
      {coverage.map((c) => (
        <div key={c.source} className="tqi-card p-4 tqi-accent-navy" data-testid={`coverage-${c.source}`}>
          <div className="flex items-start justify-between gap-2">
            <span className="tqi-eyebrow">{c.label}</span>
            <StatusBadge status={TONE[c.status] || "unknown"} label={c.status} testId={`coverage-status-${c.source}`} />
          </div>
          <div className="mt-2 font-mono text-2xl font-extrabold text-[#101C47]">{c.events == null ? <span className="text-xl font-semibold text-slate-400">Unavailable</span> : fmtNum(c.events)}</div>
          <div className="mt-1 text-xs text-slate-500">{c.events == null ? c.description : `events · synced through ${c.synced_through || "—"}${c.history_from || c.history_to ? ` · covers ${c.history_from || "…"} → ${c.history_to || "now"}` : ""}`}</div>
          {c.events != null && c.unmapped_events > 0 && <div className="mt-1 text-xs text-amber-700">{fmtNum(c.unmapped_events)} unmapped to an employee</div>}
        </div>
      ))}
    </div>
  );
}
